/// <amd-module name="Search/Hub/InPageSearchCoordinator" />
import { ObservableValue } from "VSS/Core/Observable";
import { Services, VssService } from "VSS/Platform/Context";
import { ISearchCoordinator, ISearchResult, ISearchStatus } from "VSS/Platform/Search";
import { ITfsSearchQuery } from "Tfs/Platform/Search";

/**
 * InPageSearchCoordinator is used by the Search Extension on search page i.e. for the scenario where user uses the L1 search box when he is already on search page.
 * We just return the search query that can be consumed by search hub (through searchStarted notification)
 * This is available only on search page.
 */
class InPageSearchCoordinator extends VssService implements ISearchCoordinator {
    public execute(searchQuery: ITfsSearchQuery): Promise<ISearchStatus> {
        if (searchQuery.openInNewWindow) {
            const globalCoordinator = this.pageContext.getService<ISearchCoordinator>("tfssearch-coordinator");
            return globalCoordinator.execute(searchQuery);
        }

        return Promise.resolve({ searchQuery: searchQuery, searchResult: new ObservableValue<ISearchResult | undefined>(undefined) });
    }
}

Services.add("inpage-search-coordinator", { serviceFactory: InPageSearchCoordinator });
